import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
export let routes = [
	{
		path: "/login", //登录
		component: () => import("@/view/frame/Login"),
	},
	/*前台相关路由*/
	{
		path: "/setting", // 个人设置
		component: () => import("@/view/frame/Main"),
		redirect: "/setting/home",
		children: [
			{
				path: "home",
				name: "/setting/home",
				component: () => import("@/view/setting/Home"),
			},
			{
				path: "preference",
				name: "/setting/preference",
				component: () => import("@/view/setting/Preference"),
			},
		],
	},
	{
		path: "/nmi", //固件升级
		component: () => import("@/view/Nmi"),
	},
	{
		path: "*",
		redirect: "/login",
	},
];

// fix bug 渲染bug
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
	mode: "history",
	base: stage.loc.baseRouter,
	linkActiveClass: "active", // 设置路由激活菜单的class
	// scrollBehavior: () => ({ y: 0 }),
	routes,
});

window.router = router;
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js